var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarDeleteParameter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#E1DFF2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.75 8C11.75 8.08288 11.7171 8.16237 11.6585 8.22097C11.5999 8.27958 11.5204 8.3125 11.4375 8.3125H4.5625C4.47962 8.3125 4.40013 8.27958 4.34153 8.22097C4.28292 8.16237 4.25 8.08288 4.25 8C4.25 7.91712 4.28292 7.83763 4.34153 7.77903C4.40013 7.72042 4.47962 7.6875 4.5625 7.6875H11.4375C11.5204 7.6875 11.5999 7.72042 11.6585 7.77903C11.7171 7.83763 11.75 7.91712 11.75 8Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarDeleteParameter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_delete_parameter.5fe13ae6c5128acaed3b44622ec21631.svg";